import { Flex, Spinner } from "@xometry/xometry_loft";

type LoadingSpinnerProps = {
  scale?: "full-screen" | "panel";
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  scale = "full-screen",
}) => {
  return (
    <Flex height="100%" alignItems="center" flex={1}>
      <Spinner scale={scale} />
    </Flex>
  );
};

export default LoadingSpinner;
